import { render, staticRenderFns } from "./allPolicy.vue?vue&type=template&id=5051ced4&scoped=true&"
import script from "./allPolicy.vue?vue&type=script&lang=js&"
export * from "./allPolicy.vue?vue&type=script&lang=js&"
import style0 from "./allPolicy.vue?vue&type=style&index=0&id=5051ced4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051ced4",
  null
  
)

export default component.exports